module.exports = __webpack_public_path__ + "static/img/14000002.1d024c4a.png";